<template>
	<div id="todayvideo" class="pub_pub">
		<div class="pub_title">
			<div class="img_logo">
				<img src="../imges/lebiao/jrsp.png" alt="">
			</div>
			<div class="title_t">
				<div class="imhg_ti">
					<img src="../imges/lebiao/jrsp_font.png" alt="">
				</div>
				<div class="sm_t">
					<div style="float:left"><span>今日</span><span style="color:#D7230C;">视频</span></div>
					<div class="sm_pub">好玩、好看、有趣</div>
				</div>
			</div>
			<router-link tag="div" class="ckgd" to="/todayvideodetails">
				查看更多&nbsp;>
			</router-link>
		</div>
		<div class="pub_lb jrsp_wapr" style="height: 590px;margin-top: 20px;position: relative;box-shadow: 0 4px 24px rgba(0,0,0,.16);">
			<img src="../imges/wwwwq.jpg" alt="" style="width: 100%;height: 100%;">
			<div class="divtst">
				<el-carousel indicator-position="none" :interval="5000" arrow="none">
					<el-carousel-item v-for="(item,index) in 2" :key="index">
						<div class="z_warp">
							<div @click="rnmb(o)"
								class="lb_cont" v-for="(o,index) in xptjlist[index]" :key="index">
								<div class="list_lb_img">
									<img v-lazy="o.picture" alt="">
								</div>
								<div class="xp_title" style="text-align: center;font-size: 14px;">
									{{o.title}}
								</div>
							</div>
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>
		</div>
		
		
		<div style="
		position: fixed;
		width: 100%;
		height: 100%;
		background: rgba(0,0,0,.74);
		overflow: hidden;
		top: 0;
		left: 0;
		z-index: 2147483647;" v-show="poi">
		    <div>
		      <span style="display: block;font-size: 50px;color: #FFF;float: right;" @click="uio">×</span>
		    </div>
		    <!-- <video  ref='video' poster="../../images/hz.jpg" :src="msgFormSon" controls="controls" style="position: absolute;left: 30%;top: 15vh;"></video> -->
		    <video ref='video' :src="todayvideo" controls="controls"
		           style="clear:both;display:block;margin:auto;width: 500px;height: 400px;"></video>
		  </div>
		
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				xptjlist: '',
				poi:false,
				todayvideo:''
			}
		},
		methods: {
			rnmb(o){
				console.log(o)
				this.poi = true
				this.todayvideo = o.video
			},
			uio(){
				this.poi = false
				this.todayvideo = ''
			}
		},
		async mounted() {
			let res = await http.get('api/video/index')
			let xpList = res.data.data
			let newArr = [
				[],
				[],
			]
			xpList.forEach((item, index) => {
				if (index < 4) {
					newArr[0].push(item)
				} else if (index >= 4 && index < 8) {
					newArr[1].push(item)
				} else if (index >= 8 && index < 12) {
					newArr[2].push(item)
				}
			})
			this.xptjlist = newArr
		}
	}
</script>

<style scoped>
	#todayvideo .divtst {
		width: 80%;
		position: absolute;
		bottom: 50px;
		left: 120px;
	}
	
	.divtst /deep/ .el-carousel__container{
		height: 200px;
	}

	/* 头部 */
	.pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
	}

	.pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	.img_logo>img {
		width: 100%;
		height: 100%;
	}

	.img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	.title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	.imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	.imhg_ti>img {
		width: 100%;
		height: 100%;
	}

	.sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	.sm_pub>ul::after {
		content: '';
		display: block;
		clear: both;
	}

	.sm_pub {
		float: left;
		margin-left: 40px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	.ct_title {
		float: left;

	}

	.ct_img {
		float: left;
		margin-left: 10px;
	}

	.ct_img>img {
		width: 12px;
		height: 10px;
	}

	.ckgd {
		float: right;
		margin-right: 20px;
		color: #999999;
		font-size: 15px;
		height: 36px;
		line-height: 46px;
		cursor: pointer;
	}

	/* 结尾 */


	.z_warp::after {
		content: '';
		display: block;
		clear: both;
	}

	.lb_cont {
		float: left;
		width: calc((100% - 120px)/4);
		margin-left: 24px;
		/* border: 1px solid #ececec; */
		background-color: #ececec;
	}

	.list_lb_img {
		height: 150px;
	}

	.list_lb_img>img {
		width: 100%;
		height: 100%;
	}

	.xp_title {
		margin-left: 8px;
		font-size: 16px;
		font-weight: 600;
		margin-top: 12px;
		margin-bottom: 8px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: break-all;
	}

	.ckxq_xp {
		width: 80px;
		border: 1px solid #ff4400;
		color: #ff4400;
		text-align: center;
		padding: 2px 0px;
		margin: 10px auto;
		cursor: pointer;
	}

	/* #todayvideo /deep/.el-carousel__container {
		height: 260px;
		margin-top: 20px;
	} */
</style>
